<template>
  <div>
    <div v-for="session in person.sessions" :key="session.id">
      <v-card
        class="session-card twitter-background"
        v-bind:style="{backgroundImage: 'url('+ promoImage+ ')'}"
        color="fontcolor"
        dark
        center
        :id="'twittercard-' + session.id + '-' + person.id"
      >
        <div>
          <div
            class="session-title"
            v-bind:style="{
              fontSize: calculateFontSize(session.name),
              top: calculateTop(session.name),
              color: getfontcolor()
            }"
          >
            {{ session.name }}
          </div>
          <div
            class="speaker-container"
            v-bind:style="{
              right: speakerImageRight(person.fullName),
              color: getfontcolor()
            }"
          >
            <img
              crossorigin="Anonymous"
              class="speaker-image"
              :src="fullImagePath(person.profilePicture)"
            />
            <div class="speaker-name"
                 v-bind:style="{
              color: getfontcolor()
            }">
              {{ person.fullName }}
            </div>
          </div>
        </div>
      </v-card>
      <v-flex xs6>
        <v-btn color="info" @click="generateImage(session.id, person.id, person.fullName)"
          >Generate Image</v-btn
        >
        <h4>COPY</h4>
        <div v-html="generatePromoText(promoText, session.name, getTwitterHandleFromPerson(person)) "></div>
      </v-flex>
    </div>
    <img id="img1" src="" />
    <canvas
      id="canvas"
      width="1200"
      height="675"
      style="display: none;"
    ></canvas>
    <!--<div id="png-container" style="display: none;"></div>-->
    <a
      href="#"
      class="button"
      id="btn-download"
      download="my-file-name.png"
      style="display: none;"
    ></a>
  </div>
</template>

<script>
import domtoimage from "dom-to-image";

export default {
  props: {
    person: {
      type: Object,
      required: true
    },
    promoImage: {
      type: String,
      required: true
    },
    promoText: {
      type: String,
      required: true
    },
    fontcolor: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    showDetails() {},
    getfontcolor() {
      return this.fontcolor
    },
    calculateFontSize(text) {
      return 70 - text.length * 0.1 + "px";
    },
    calculateTop(text) {
      return 400 - text.length * 1.5 + "px";
    },
    fullImagePath(avatar_path) {
      // let imagePath = "https://cfp.connectevents.io/" + avatar_path;
      // imagePath = imagePath.replace("large", "original");
      return avatar_path;
    },
    speakerNameRight(name) {
      return -140 + name.length * 5 + "px";
    },
    speakerImageRight(name) {
      return -20 + name.length * 4  + "px";
    },
    generatePromoText(template, title, twitterName) {
      let templateTemplate = template.replace("{{title}}", title);
      templateTemplate = templateTemplate.replace("{{twitterHandle}}", twitterName);
      templateTemplate = templateTemplate.replace("@@", "@");

      return templateTemplate;
    },
    getTwitterHandleFromPerson(person) {
      if (person && person.links[0]) {
        return  person.links[0].url.substring(person.links[0].url.lastIndexOf('/')+1)
      } else {return "notwitter"}
    },
    generateImage(sessionId, speakerId, speakerName) {
      let cardId = "twittercard-" + sessionId + "-" + speakerId;
      var node = document.getElementById(cardId);

      domtoimage.toSvg(node).then(function(dataUrl) {
        console.log("generating img");
        // var img1 = document.getElementById("img1");
        // document.getElementById("img1").src = dataUrl;

        var canvas = document.getElementById("canvas");
        var ctx = canvas.getContext("2d");
        //var DOMURL = self.URL || self.webkitURL || self;
        var img = new Image();
        var url = dataUrl;
        img.onload = function() {
          // ctx.drawImage(img, 0, 0);
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          var png = canvas.toDataURL("image/png");
          // document.querySelector("#png-container").innerHTML =
          //   '<img src="' + png + '"/>';
          // DOMURL.revokeObjectURL(png);
          var link = document.getElementById("btn-download");
          link.download = speakerName+"-"+sessionId+".png";
          link.href = png;
          link.click();
          ctx.clearRect(0, 0, canvas.width, canvas.height);
        };
        img.src = url;
      });
    }
  },
  mounted() {
    this.$root.$on("generateAllTwitterImages", () => {
      var generateImage = this.generateImage;

      var person = this.person;
      this.person.sessions.forEach(function(session) {
        generateImage(session.id, person.id, person.fullName);
      });
    });
  }
};
</script>

<style scoped>
.session-title {
  text-align: left;
  position: absolute;
  /*top: 120px;*/
  left: 20px;
  width: 60%;
  line-height: 120%;
  /*font-size: 32px;*/
}

.speaker-container {
  height: 480px;
  position: absolute;
  /*right: 75px;*/
  bottom: 0px;
}

.speaker-image {
  height: 400px;
  display: block;
  /*max-width: 400px;*/
  margin: auto;
}

.speaker-name {
  /*width: 450px;*/
  /*position: absolute;*/
  /*bottom: 2px;*/
  color: ivory;
  font-size: 44px;
  right: 0px;
}

.session-card {
  margin-left: 0px;
  margin-top: 0px;

  width: 1200px;
  height: 675px;
}

.twitter-background {
  background-image: url("../assets/ctpromo.png");
  background-position: top;
  background-size: cover;
  background-size: 100%;
}
</style>
